import { Component, inject } from '@angular/core';
import {
 UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule
} from '@angular/forms';
import {
 MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose
} from '@angular/material/dialog';
import { ShippingDetails } from '@fairandsmart/types';
import { MatProgressBar } from '@angular/material/progress-bar';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomerService } from '../../customer.service';

export interface UpdateShippingInfosDialogComponentData {
  infos: ShippingDetails;
  service: CustomerService;
}

@Component({
    selector: 'fs-update-shipping-infos-dialog',
    templateUrl: './update-shipping-infos-dialog.component.html',
    styleUrls: ['./update-shipping-infos-dialog.component.scss'],
    imports: [MatProgressBar, MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class UpdateShippingInfosDialogComponent {
  private dialogRef = inject<MatDialogRef<UpdateShippingInfosDialogComponent, ShippingDetails>>(MatDialogRef);

  private fb = inject(UntypedFormBuilder);

  data = inject<UpdateShippingInfosDialogComponentData>(MAT_DIALOG_DATA);

  public form: UntypedFormGroup;

  public error: boolean;

  public pending: boolean;

  constructor() {
    const data = this.data;

    if (!data.infos) {
      data.infos = {
        name: '',
        phone: '',
      };
    }
    if (!data.infos.address) {
      data.infos.address = {
        line1: '',
        line2: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
      };
    }
    this.form = this.fb.group({
      name: [data.infos.name, Validators.required],
      phone: [data.infos.phone],
      address: this.fb.group({
        line1: [data.infos.address.line1, Validators.required],
        line2: [data.infos.address.line2],
        postal_code: [data.infos.address.postal_code, Validators.required],
        city: [data.infos.address.city, Validators.required],
        state: [data.infos.address.state],
        country: [data.infos.address.country],
      }),
    });
  }

  submit(): void {
    if (this.form.valid) {
      this.pending = true;
      const shippingDetails: ShippingDetails = this.emptyToNull(this.form.getRawValue());
      this.form.disable();
      this.data.service.setCustomerShippingDetails(shippingDetails).subscribe({
        next: () => {
          this.dialogRef.close(shippingDetails);
        },
        error: () => {
          this.form.enable();
          this.pending = false;
        },
      });
    }
  }

  private emptyToNull(object: any): any {
    Object.keys(object).forEach((key) => {
      if (object[key] != null) {
        if (object[key].length === 0) {
          object[key] = null;
        } else if (typeof (object[key]) === 'object') {
          object[key] = this.emptyToNull(object[key]);
        }
      }
    });
    return object;
  }
}
